@switch (question().ratingType) {
  @case (ratingType.numeric) {
    <div class="rating-view__scale-container" ratingsPosition [scale]="question().ratingScale">
      <mat-button-toggle-group name="rating" hideSingleSelectionIndicator [vertical]="question().ratingScale > maxXRatingScale">
        @for (scale of [].constructor(question().ratingScale); track scale; let index = $index) {
          <mat-button-toggle [checked]="index + 1 === questionGrp().get('value').value" [value]="index + 1" (click)="onRate(index + 1)">
            <span class="fs__md">{{ index + 1 }}</span>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>

      <div class="rating-view__scale-label">
        <span class="sub-label fs__md">{{ question().minValueText }}</span>
        <span class="sub-label fs__md">{{ question().maxValueText }}</span>
      </div>
    </div>
  }

  @case (ratingType.descriptive) {
    <div class="rating-view__descriptive-container">
      @for (option of visibleOptions$(); track option.id) {
        <div
          class="rating-view__descriptive-content"
          [class.selected]="questionGrp().get('value').value === option.value"
          (click)="onSelectDescriptive(option.value)"
        >
          <div class="rating-view__descritive-index">
            <span class="fs__sm">{{ option.value }}</span>
          </div>
          <div class="rating-view__descritive-text survey-viewer__html-content fs__md" [innerHTML]="option.text"></div>
        </div>
      }
    </div>
  }

  @case (ratingType.stars) {
    <div #starContainer class="rating-view__stars-container" ratingsPosition [scale]="question().ratingScale" [maxXRatingScale]="maxXStarsRatingScale$()">
      <mat-button-toggle-group
        name="stars"
        hideSingleSelectionIndicator
        [ngClass]="applyStarsContainerMaxWidth$() ? 'stars-container-max-width' : ''"
        [vertical]="question().ratingScale > maxXStarsRatingScale$()"
      >
        @for (scale of [].constructor(question().ratingScale); track scale; let index = $index) {
          <mat-button-toggle [value]="index + 1" (click)="onRate(index + 1)">
            <fa-icon [class.highlighted]="questionGrp().get('value').value > index" [icon]="faStar"></fa-icon>
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
      <div class="rating-view__scale-label" [ngClass]="applyStarsContainerMaxWidth$() ? 'stars-container-max-width' : ''">
        <span class="sub-label fs__sm">{{ question().minValueText }}</span>
        <span class="sub-label fs__sm">{{ question().maxValueText }}</span>
      </div>
    </div>
  }
}
